import { Expose } from "class-transformer";

export class CreateTrainingCategoryDto {
  @Expose()
  name: string;
}
